{
    "ConsidermovedtounresolvedasoverflowedLabel": "Considere as chamadas movidas para dispositivos não resolvidos como em sobrecarga:",
    "StatisticCalculations_SectionHeader": "Cálculos estatísticos",
    "StatisticCalculations_SectionPara": "Pode escolher se as chamadas são consideradas em sobrecarga ou abandonadas quando a aplicação termina de forma deliberada a respetiva modelação para chamadas movidas para localizações de dispositivos não monitorizadas ou desconhecidas.",
    "NAME": "StatisticCalculations"
}